import PropTypes from 'prop-types';
import Icon, { GLYPHS } from './icon';

const ICON_BY_CARD_BRAND = {
  'american express': GLYPHS.paymentCardAmex,
  'diners club': GLYPHS.paymentCardDiners,
  discover: GLYPHS.paymentCardDiscover,
  jcb: GLYPHS.paymentCardJcb,
  mastercard: GLYPHS.paymentCardMastercard,
  unionpay: GLYPHS.paymentCardUnionpay,
  unknown: GLYPHS.paymentCardUnknown,
  visa: GLYPHS.paymentCardVisa,
};

const PaymentCardIcon = ({ cardBrand }) => (
  <Icon glyph={ICON_BY_CARD_BRAND[cardBrand.toLowerCase()] || ICON_BY_CARD_BRAND.unknown} />
);

PaymentCardIcon.propTypes = {
  cardBrand: PropTypes.string,
};

PaymentCardIcon.defaultProps = {
  cardBrand: 'unknown',
};

export default PaymentCardIcon;
